// extracted by mini-css-extract-plugin
module.exports = {"section":"TheFooter_section_2cP-f","wrapper":"TheFooter_wrapper_O5D7j","content":"TheFooter_content_3XHr_"};